<rotec-modal-v2 title="Upload Task List" [darkMode]="true" width="80vw" height="95vh" class="modal">
  <ng-container ngProjectAs="modal-main" class="modal-main">
    <div class="modal-container">
      <div class="workflow-header">
        <rotec-workflow
          [darkMode]="true"
          [horizontal]="true"
          [checkOnValid]="true"
          [nextButtonClick$]="nextClick$"
          [previousButtonClick$]="previousClick$"
          [items]="workflowItems"
          (selectedItemChange)="itemChanged($event)"
        ></rotec-workflow>
      </div>
      <div class="workflow-content">
        <ng-container [ngSwitch]="activeItem.title">
          <ng-container *ngIf="isMachineTaskMode; else tooling">
            <machines-step
              #step
              *ngSwitchCase="'Machines'"
              [workflowItem]="workflowItems[0]"
              (stepChanged)="stepStateChanged($event)"
            ></machines-step>
          </ng-container>
          <ng-template #tooling>
            <tooling-step
              #step
              *ngSwitchCase="'Tooling'"
              [workflowItem]="workflowItems[0]"
              (stepChanged)="stepStateChanged($event)"
            ></tooling-step>
          </ng-template>

          <tasklist-step
            #taskList
            *ngSwitchCase="'Select Tasklist'"
            [workflowItem]="workflowItems[1]"
            [isMachineTaskMode]="isMachineTaskMode"
            [pictureService]="pictureService"
            (fileUpload)="fileUpload($event)"
            (stepChanged)="stepStateChanged($event)"
          ></tasklist-step>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-secondary dark class="button cancel" (click)="close()">
      {{ 'COMMON_Cancel' | translate }}
    </button>
    <button
      rotec-button-primary-v2
      dark
      class="button back"
      [disabled]="previousButtonDisabled || (loading$ | async)"
      (click)="previousStep()"
    >
      {{ 'COMMON_Back' | translate }}
    </button>
    <ng-container *ngIf="!createButton; else saveButton">
      <button
        rotec-button-active
        dark
        class="button next"
        [disabled]="nextButtonDisabled"
        (click)="nextStep()"
      >
        {{ 'COMMON_Next' | translate }}
      </button>
    </ng-container>
    <ng-template #saveButton>
      <button
        rotec-button-active
        dark
        class="button next"
        [disabled]="nextButtonDisabled"
        (click)="save()"
      >
        {{ 'COMMON_Save' | translate }}
      </button>
    </ng-template>
  </ng-container>
</rotec-modal-v2>
